export const MedicareCardType = Object.freeze({
  GREEN: 'Green',
  BLUE_INTERIM: 'Blue (Interim)',
  YELLOW_RECIPROCAL: 'Yellow (Reciprocal)',
});

export const MedicareCardTypeCodeEnum = Object.freeze({
  GREEN: 'G',
  BLUE_INTERIM: 'B',
  YELLOW_RECIPROCAL: 'Y',
});